import { classNames } from 'primereact/utils'
const TRANSITIONS = {
    overlay: {
        classNames: {
            enter: 'opacity-0 scale-75',
            enterActive:
                'opacity-100 !scale-100 transition-transform transition-opacity duration-150 ease-in',
            exit: 'opacity-100',
            exitActive:
                '!opacity-0 transition-opacity duration-150 ease-linear',
        },
    },
}

const overlayPanel = {
    root: () => {
        return {
            className: classNames(
                'rounded-md shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] bg-white',
                'overflow-hidden',
                'absolute mt-2',
                'z-40',
                // Before: Triangle
                'before:absolute before:-top-2 before:-ml-2 before:left-[calc(var(--overlayArrowLeft,0)+1.25rem)] z-0',
                'before:w-0 before:h-0',
                'before:border-transparent before:border-solid',
                'before:border-x-2 before:border-2',
                'before:border-t-0 before:border-b-surface-300/10',

                'after:absolute after:-top-2 after:-ml-2 after:left-[calc(var(--overlayArrowLeft,0)+1.25rem)]',
                'after:w-0 after:h-0',
                'after:border-transparent after:border-solid',
                'after:border-x-2 after:border-2',
                'after:border-t-0 after:border-b-surface-0'
            ),
        }
    },
    transition: TRANSITIONS.overlay,
}

export default overlayPanel
